export enum ChannelType {
  BATCH_BILLING = 'BATCH_BILLING',
  PHONE = 'PHONE',
  CHAT = 'CHAT',
  MAIL = 'MAIL',
  WEB = 'WEB',
  SMS = 'SMS',
  FAX = 'FAX',
  SUPPLIER_PORTAL = 'SUPPLIER_PORTAL',
  UNKNOWN_SUPPLIER = 'UNKNOWN SUPPLIER'
}
